import directives from './directives.js'

export default {
  install(app) {
    Object.keys(directives).forEach((key) => {
      app.directive(key, directives[key]) // 使用 app.directive 注册指令
    })
  },
}
